<template>
  <div>
    <div class="left_list">
      <div class="left_list_title left_list_title2">
        <span>商业业态分布</span>
        <img
          style="cursor: pointer"
          :class="isTrue ? '' : 'close_opcity'"
          :src="
            isTrue
              ? require('@/assets/img/img_switch_open.png')
              : require('@/assets/img/img_switch_close.png')
          "
          @click="changeIsTrue()"
        />
      </div>
      <div class="commercial">
        <div
          class="commercial_left"
          id="syfb"
          style="width: 494.25px; height: 272px"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  props: {
    mall_category_distribution: {
      typeof: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isTrue: false,
      data1: [
      ],
    };
  },
  components: {},
  watch: {
    mall_category_distribution: {
      deep: true,
      handler: function (val) {
        this.getData();
      },
    },
  },
  mounted() {
    this.chartInfo();
  },

  created() {},
  methods: {
    //商业业态分布点击事件
    changeIsTrue() {
      if (!this.isTrue) {
        this.isTrue = true;
        console.log("打开商业业态分布点击事件");
        //打开时触发的事件
        //打开开关显示商业业态分布定位，点击定位图标显示详情
      } else {
        this.isTrue = false;
        console.log("关闭商业业态分布点击事件");
        //关闭时触发的事件
      }
    },
    getData() {
      // console.log(this.mall_category_distribution)
      if (this.mall_category_distribution.length > 0) {
        this.data1 = [];
        for (let i = 0; i < this.mall_category_distribution.length; i++) {
          this.data1.push({
            value: Number(this.mall_category_distribution[i].value),
            name: this.mall_category_distribution[i].name,
          });
        }
      }
      this.chartInfo();
    },
    chartInfo() {
      var that = this;
      console.log(that.data1);
      const color = [
        "#38f1f1",
        "#3950f9",
        "#4dabf5",
        "#fad900",
        "#bedeff",
        "#ffffff",
      ];

      var option = {
        // backgroundColor: '#0c1629',
        title: [
          {
            text: "整体\n业态",
            left: "25%",
            x: "center",
            y: "center",
            textStyle: {
              fontSize: 20,
              color: "#fff",
              lineHeight: 30,
            },
          },
        ],
        polar: {
          radius: ["80%", "90%"],
          center: ["30%", "50%"],
        },
        angleAxis: {
          max: 100,
          show: false,
        },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        legend: {
          selectedMode: true,
          icon: "circle",
          orient: "vertical",
          right: "0%",
          top: "center",
          itemWidth: 10,
          itemHeight: 10,
          formatter(name) {
            // 该函数用于设置图例显示后的百分比
            let data = that.data1;
            let total = 0;
            let value = 0;
            data.forEach((item) => {
              total += item.value;
              if (item.name == name) {
                value = item.value;
              }
            });
            let p = Number(value) // 求出百分比
            // return ['{a|' + `${name}` + '}{b|' + `${value}` + '}{b1|项}{c|' + `${p || '0'}` + '}{c1|%' + '}']
            return ["{a|" + `${name}` + "}{b|" + `${p}` + "}{c1|%" + "}"];
          },
          textStyle: {
            fontSize: 18,
            color: "#b4b7bd",
            padding: [2, 5],
            rich: {
              b: {
                padding: [0, 2, 0, 40],
                verticalAlign: "sub",
                fontSize: 20,
                color: "#fff",
              },
              a: {
                  width:80,
                fontSize: 18,

              },
              c1: {
                color: "#fff",
              },
            },
          },
        },
        series: [
          {
            name: "",
            type: "bar",
            barWidth: 30,
            showBackground: true,
            backgroundStyle: {
              color: "#141b37",
            },
            data: [25],
            coordinateSystem: "polar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0,
                    color: "#217c89",
                  },
                  {
                    offset: 1,
                    color: "#141b37",
                  },
                ]),
              },
            },
          },

          {
            type: "pie",
            radius: ["60%", "70%"],
            center: ["30%", "50%"],
            hoverAnimation: false,
            startAngle: 180,
            selectedMode: "single",
            label: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return color[params.dataIndex];
                },
              },
            },
            data: this.data1,
            z: 1,
          },
        ],
      };

      var myChart = echarts.init(document.getElementById("syfb"));
      myChart.clear();
      myChart.setOption(option);
      // 随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>
<style scoped src="@/assets/css/index3.css">
</style>
<style>
.left_list_title > img {
  width: 40px;
  height: 22px;
  position: absolute;
  right: 24px;
  top: 50%;
  margin-top: -11px;
}

/* 关闭时透明度 */
.close_opcity {
  opacity: 0.4;
}
</style>